'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-localization/~/react/react.js
// module id = 1122
// module chunks = 1